/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipes_Empty_ImportInputs */

const en_recipes_empty_import = /** @type {(inputs: Recipes_Empty_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import your first recipe`)
};

const de_recipes_empty_import = /** @type {(inputs: Recipes_Empty_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstes Rezept importieren`)
};

/**
* | output |
* | --- |
* | "Import your first recipe" |
*
* @param {Recipes_Empty_ImportInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipes_empty_import = /** @type {((inputs?: Recipes_Empty_ImportInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipes_Empty_ImportInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipes_empty_import(inputs)
	return en_recipes_empty_import(inputs)
});